import http from '@/utils/http';

/**
 * 获取分页查询联系人-cyj
 */
export function getList(data) {
    return http({
        url: '/api-lcrm/asset/transfer/contact/page',
        method: 'post',
        data
    });
};

/**
 * 保存联系人交接明细-cyj
 */
export function updateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/contact/save',
        method: 'post',
        data
    });
};

/**
 * 批量保存联系人交接明细-cyj
 */
export function batchUpdateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/contact/batchSave',
        method: 'post',
        data
    });
};

/**
 * 导入-cyj
 */
export function importAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/contact/importContact',
        method: 'post',
        data
    });
};
